export function getAnimationEndEventName(): string | false {
	const element = document.createElement('_');
	const animations = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		WebkitTransition: 'webkitAnimationEnd',
		transition: 'animationend',
	};

	for (const animation in animations) {
		if (element.style[animation] !== undefined) {
			return animations[animation];
		}
	}

	return false;
}
